jQuery( function ( $ ) {
    'use strict';

    // pma_show_hide_search_form();

    pma_back_to_top_link();
    pma_handle_menu_click();

    jQuery('#top-feature-boxes .top-feature-box').matchHeight();

    // Allow smooth scroll
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
    });

});

function pma_handle_menu_click() {
    let dropdown_toggle_button = jQuery('button.navbar-toggler');
    let mobile_close_button = jQuery('#mobile-close-button');

    dropdown_toggle_button.on('click', function(event) {
        jQuery('#header-wrapper').toggleClass('mobile-menu');
    });
    mobile_close_button.on('click', function(event) {
        jQuery('#header-wrapper').removeClass('mobile-menu');
    });
}
function pma_show_hide_search_form() {
    let search_icon = jQuery( '#search-icon' );
    let search_icon_wrapper = search_icon.parent();
    let search_form = jQuery( '.search-form' );
    let search_field = jQuery('.search-field');

    search_icon.on( 'click', function() {
        search_icon_wrapper.toggleClass( 'expanded' );
        if( search_icon_wrapper.hasClass( 'expanded' ) ) {
            search_form.fadeIn();
            search_icon.removeClass( 'fa-search' ).addClass( 'fa-times' );
            search_field.focus();
        } else {
            search_form.fadeOut();
            search_icon.addClass( 'fa-search' ).removeClass( 'fa-times' );
        }
    } );
}
function pma_back_to_top_link() {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 50) {
            jQuery('#back-to-top').fadeIn();
        } else {
            jQuery('#back-to-top').fadeOut();
        }
    });
    // scroll body to 0px on click
    jQuery('#back-to-top').on('click touchstart', function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 400);
        return false;
    });
}